import { INSIGHT_TYPE } from "@/constants";
import { FilterOptions } from "@/types/FilterOptions";
import { SearchFilterV4 } from "@/types/SearchFilter";
import { Checkbox } from "@components/ui/checkbox";
import {
  CommandGroup,
  CommandItem,
  CommandSeparator,
} from "@components/ui/command";
import { Trans } from "@lingui/react/macro";
import { ChevronLeftIcon } from "lucide-react";

export default function PageInsightTypes({
  options,
  onChange,
  value,
  onBack,
}: {
  onChange?: (value: SearchFilterV4, clear?: boolean) => void;
  value: SearchFilterV4["insight_types"];
  options: FilterOptions["filter_insight_types"];
  onBack?: () => void;
}) {
  // Helpers
  const isArray = Array.isArray(value);

  // Temporarly hide high reach insight type since we don't have any since Jul 2025
  const filteredOptions = options.filter(
    ([insightType]) => insightType !== INSIGHT_TYPE.HIGH_REACH_MENTION
  );

  const isAllSelected = isArray && value.length === filteredOptions.length;

  return (
    <>
      {onBack && (
        <>
          <CommandGroup>
            <CommandItem onSelect={onBack}>
              <ChevronLeftIcon />
              <Trans>Tillbaka</Trans>
            </CommandItem>
          </CommandGroup>

          <CommandSeparator />
        </>
      )}

      <CommandGroup>
        {isAllSelected ? (
          <CommandItem
            onSelect={() => {
              onChange?.({
                insight_types: undefined,
              });
            }}
          >
            <Trans>Avmarkera alla</Trans>
          </CommandItem>
        ) : (
          <CommandItem
            onSelect={() => {
              onChange?.({
                insight_types: filteredOptions.map(([value]) => value),
              });
            }}
          >
            <Trans>Markera alla</Trans>
          </CommandItem>
        )}
      </CommandGroup>

      <CommandSeparator />

      <CommandGroup>
        {filteredOptions.map(([insightType, label]) => {
          const isChecked = isArray
            ? value.includes(insightType)
            : value === insightType;

          return (
            <CommandItem
              data-filter-value={insightType}
              key={insightType}
              onSelect={() => {
                if (isChecked) {
                  onChange?.({
                    insight_types: isArray
                      ? value.filter((it) => it !== insightType)
                      : undefined,
                  });
                } else {
                  onChange?.({
                    insight_types: isArray
                      ? [...value, insightType]
                      : value
                        ? [value, insightType]
                        : [insightType],
                  });
                }
              }}
            >
              <Checkbox checked={isChecked} className="pointer-events-none" />
              {label}
            </CommandItem>
          );
        })}
      </CommandGroup>
    </>
  );
}
